import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl, Map } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { useMapBox } from './composables/useMapBox'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxZoomControl',
  props: {
    position: null
  },
  setup(__props: any) {

const props = __props as {
	position?: ControlPosition
};



let control: IControl | undefined

const zoomInButton = ref<HTMLElement>()
const zoomOutButton = ref<HTMLElement>()
const resetNorthButton = ref<HTMLElement>()

const { map } = useMapBox()

onMounted(() => {
	let container: HTMLDivElement

	control = {
		onAdd(map: Map) {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			zoomInButton.value?.addEventListener('click', () => map.zoomIn())
			zoomOutButton.value?.addEventListener('click', () => map.zoomOut())
			resetNorthButton.value?.addEventListener('click', () => map.resetNorth())

			container.appendChild(zoomInButton.value!)
			container.appendChild(zoomOutButton.value!)
			container.appendChild(resetNorthButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	setTimeout(() => map?.value?.addControl(control!, props.position || 'top-right'), 500)
})

onUnmounted(() => {
	if (control) map?.value?.removeControl(control)
})

return { __sfc: true,props, control, zoomInButton, zoomOutButton, resetNorthButton, map, Icon }
}

})